import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SoftwareConsultingRoutingModule } from './software-consulting-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SoftwareConsultingRoutingModule
  ]
})
export class SoftwareConsultingModule { }
